import { createSelector } from 'reselect';

export const selectTripFeatureState = (state) => state.search;

export const selectTripSummary = createSelector(
  selectTripFeatureState,
  (state) => state.tripSummary
);
export const selectAirResponse = createSelector(
  selectTripSummary,
  (state) => state && state.AirResponses && state.AirResponses[0]
);
export const selectAirTotalCloud = createSelector(
  selectTripSummary,
  (state) => state && state?.AirResponses[0]?.TotalAmount
);
export const selectRailResponse = createSelector(
  selectTripSummary,
  (state) => state && state.RailResponses
);

export const selectCarResponses = createSelector(
  selectTripSummary,
  (state) => state && state.CarResponses
);
export const selectHotelResponses = createSelector(
  selectTripSummary,
  (state) => state && state.HotelResponses
);
export const selectAirTotal = createSelector(
  selectAirResponse,
  (state) => (state && state.TotalAmount) || 0
);

export const selectRailTotal = createSelector(
  selectRailResponse,
  (state) => (state && state.TotalFare) || 0
);

export const selectHotelTotalObj = createSelector(
  selectHotelResponses,
  (state) =>
    (state &&
      state.reduce(
        (r, c) => {
          r.Total += c.TotalPrice;
          r.Tax += c.TaxTotalDays;
          return r;
        },
        { Total: 0, Tax: 0 }
      )) || { Total: 0, Tax: 0 }
);

export const selectHotelTotal = createSelector(
  selectHotelTotalObj,
  (state) => state && state.Total
);

export const selectHotelTotalTax = createSelector(
  selectHotelTotalObj,
  (state) => state && state.Tax
);

export const selectCarTotalObj = createSelector(
  selectCarResponses,
  (state) =>
    (state &&
      state.reduce(
        (r, c) => {
          r.Total += c.TotalFare;
          r.Tax += c.TotalTax;
          return r;
        },
        { Total: 0, Tax: 0 }
      )) || { Total: 0, Tax: 0 }
);

export const selectCarTotal = createSelector(selectCarTotalObj, (state) => state && state.Total);

export const selectCarTotalTax = createSelector(selectCarTotalObj, (state) => state && state.Tax);

export const selectTravelCart = createSelector(selectTripFeatureState, (state) => state.travelCart);

export const selectTravelCartCreditCards = createSelector(
  selectTravelCart,
  (state) => (state && state.CreditCards) || []
);

export const selectGeolocation = createSelector(
  selectTripFeatureState,
  (state) => state.geolocation
);

export const selectAirLegs = createSelector(selectAirResponse, (state) => state && state.AirLegs);

export const selectAirSegments = createSelector(
  selectAirLegs,
  (state) => state && state.reduce((r, airLeg) => r.concat(airLeg.AirSegments), [])
);

export const selectCheckoutStepperSteps = createSelector(selectTravelCart, (travelCart) => {
  if (travelCart && travelCart.IsAir) {
    return ['Travelers', 'Seats', 'Payment', 'Receipt'];
  } else {
    return ['Travelers', 'Payment', 'Receipt'];
  }
});

export const selectTravelCartPassengers = createSelector(
  selectTripFeatureState,
  (state) => state.travelCart?.Passengers
);

export const selectIsReasonCodeDropdownAllowed = createSelector(
  selectTravelCart,
  (state) => state.IsReasonCodeAllowed
);
